export const CASUS_SCORE = {
  masterTableName: "MC_CASUS_SCORE",
  tableName: "MC_CASUS_SCORE_DET",
  columnName: "MCS_ID",
  columnValue: 0,
  title: "casus.title",
  rows: [
    {
      title: "id",
      value: "ID",
    },
    {
      title: "date",
      value: "PROCESS_TIME",
    },
    {
      title: "RESPIRATORY",
      value: "RESPIRATORY_XNAME",
    },
    {
      title: "CREATININE",
      value: "CREATININE_XNAME",
    },
    {
      title: "CVVH",
      value: "CVVH_XNAME",
    },
    {
      title: "BILIRUBIN",
      value: "BILIRUBIN_XNAME",
    },
    {
      title: "PAR",
      value: "PAR_XNAME",
    },
    {
      title: "LACTIC_ACID",
      value: "LACTIC_ACID_XNAME",
    },
    {
      title: "INTRA_BALL_PUMP",
      value: "INTRA_BALL_PUMP_XNAME",
    },
    {
      title: "VENTRI_ASSIST_DEVICE",
      value: "VENTRI_ASSIST_DEVICE_XNAME",
    },
    {
      title: "PLATELET_COUNT",
      value: "PLATELET_COUNT_XNAME",
    },
    {
      title: "NEUROLOGICAL_COUNT",
      value: "NEUROLOGICAL_COUNT_XNAME",
    },
    {
      title: "SCORE",
      value: "SCORE",
    },
  ],
  fields: [
    { field: "date", headerName: "datetime", flex: 1 },
    { field: "RESPIRATORY", headerName: "casus.respiratory", flex: 1 },
    { field: "CREATININE", headerName: "casus.creatinin", flex: 1 },
    { field: "CVVH", headerName: "casus.cvhh", flex: 1 },
    { field: "BILIRUBIN", headerName: "casus.bilirrubin", flex: 1 },
    { field: "PAR", headerName: "casus.par", flex: 1 },
    { field: "LACTIC_ACID", headerName: "casus.lactic", flex: 1 },
    { field: "INTRA_BALL_PUMP", headerName: "casus.intra", flex: 1 },
    { field: "VENTRI_ASSIST_DEVICE", headerName: "casus.ventri", flex: 1 },
    { field: "PLATELET_COUNT", headerName: "casus.trombocit", flex: 1 },
    {
      field: "NEUROLOGICAL_COUNT",
      headerName: "casus.neurology-state",
      flex: 1,
    },
    {
      field: "SCORE",
      headerName: "casus.total-score",
      flex: 1,
      computed: false,
      calculate: (row: any) => {
        if (!row) return 0;
        const respiratoryScore = Number(row.RESPIRATORY_XVALUE) || 0;
        const creatinineScore = Number(row.CREATININE_XVALUE) || 0;
        const cvvhScore = Number(row.CVVH_XVALUE) || 0;
        const bilirubinScore = Number(row.BILIRUBIN_XVALUE) || 0;
        const parScore = Number(row.PAR_XVALUE) || 0;
        const lacticAcidScore = Number(row.LACTIC_ACID_XVALUE) || 0;
        const intraBallPumpScore = Number(row.INTRA_BALL_PUMP_XVALUE) || 0;
        const ventriAssistDeviceScore =
          Number(row.VENTRI_ASSIST_DEVICE_XVALUE) || 0;
        const plateletCountScore = Number(row.PLATELET_COUNT_XVALUE) || 0;
        const neurologicalCountScore =
          Number(row.NEUROLOGICAL_COUNT_XVALUE) || 0;

        const totalScore =
          respiratoryScore +
          creatinineScore +
          cvvhScore +
          bilirubinScore +
          parScore +
          lacticAcidScore +
          intraBallPumpScore +
          ventriAssistDeviceScore +
          plateletCountScore +
          neurologicalCountScore;

        return totalScore;
      },
    },
  ],
  mcpConfig: {
    RESPIRATORY: {
      mcpId: 882,
      field: "RESPIRATORY",
      scoreField: "RESPIRATORY_XVALUE",
    },
    CREATININE: {
      mcpId: 883,
      field: "CREATININE",
      scoreField: "CREATININE_XVALUE",
    },
    CVVH: { mcpId: 884, field: "CVVH", scoreField: "CVVH_XVALUE" },
    BILIRUBIN: {
      mcpId: 885,
      field: "BILIRUBIN",
      scoreField: "BILIRUBIN_XVALUE",
    },
    PAR: { mcpId: 886, field: "PAR", scoreField: "PAR_XVALUE" },
    LACTIC_ACID: {
      mcpId: 887,
      field: "LACTIC_ACID",
      scoreField: "LACTIC_ACID_XVALUE",
    },
    INTRA_BALL_PUMP: {
      mcpId: 888,
      field: "INTRA_BALL_PUMP",
      scoreField: "INTRA_BALL_PUMP_XVALUE",
    },
    VENTRI_ASSIST_DEVICE: {
      mcpId: 889,
      field: "VENTRI_ASSIST_DEVICE",
      scoreField: "VENTRI_ASSIST_DEVICE_XVALUE",
    },
    PLATELET_COUNT: {
      mcpId: 890,
      field: "PLATELET_COUNT",
      scoreField: "PLATELET_COUNT_XVALUE",
    },
    NEUROLOGICAL_COUNT: {
      mcpId: 891,
      field: "NEUROLOGICAL_COUNT",
      scoreField: "NEUROLOGICAL_COUNT_XVALUE",
    },
  } as Record<string, { mcpId: number; field: string; scoreField: string }>,
  formData: {
    MCS_ID: "",
    SCORE: 0,
    NEUROLOGICAL_COUNT: "",
    PLATELET_COUNT: "",
    VENTRI_ASSIST_DEVICE: "",
    INTRA_BALL_PUMP: "",
    LACTIC_ACID: "",
    PAR: "",
    BILIRUBIN: "",
    CVVH: "",
    CREATININE: "",
    RESPIRATORY: "",
    CUSER: "",
    NURSE_ID: "",
    PROCESS_TIME: new Date(),
    CTIME: new Date(),
  },
  chartScoreField: "SCORE",
  chartTimeField: "CTIME",
};
